if (!customElements.get('coco-shuffle')) {
  class CocoShuffle extends HTMLElement {
    constructor() {
      super();
      this.selectedProduct = null;
    }
    
    connectedCallback() {
      this.products = JSON.parse(this.dataset.productsJson.replace("}]},]", "}]}]")
        .replaceAll('%27', '&apos;')
        .replaceAll('%22', '&quot;')
        );
      this.baseProduct = this.products.find(product => product.tags.find(x => x === 'base_product')) ?? null;
      this.detailsWrapper = document.querySelector('[data-details-module-wrapper]');
      this.selectedProduct = this.products.find(({ handle }) => window.location.pathname.includes(handle));
      const initialProductId = this.querySelector('input[data-product-id]:checked')?.dataset?.productId;

      if (this.selectedProduct?.id === this.baseProduct?.id || !this.selectedProduct) {
        this.selectedProduct = this.products.find(x => x.id === initialProductId);
      }
                                  
      this.addDelegatedClickListeners();
      this.createCustomEvents();
      document.addEventListener('DOMContentLoaded', () => {
        // any elements that might not exist yet when the ACE gets added to the DOM
        this.imagesWrapper = [...this.querySelectorAll('[data-product-images]')];
        this.detailsWrapper.innerHTML = document.querySelector(`[data-details-module="${this.selectedProduct.id}"]`).innerHTML;
      });
    }
      
    addDelegatedClickListeners() {
      this.addEventListener('mouseover', e => {
        const enteredElement = e.target.closest('[data-hover-title]');
        if (!enteredElement) return;
        
        const flavorDisplayEl = this.querySelector('[data-display="flavor"]');    
            
        flavorDisplayEl.innerHTML = enteredElement.dataset.hoverTitle;
        enteredElement.addEventListener('mouseleave', () => {
          flavorDisplayEl.innerHTML = this.selectedProduct.flavor;
        }, { once: true });
        
      });
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const {
          action,
          productId,
          mapHandle,
          mapType,
          index
        } = clickedElement.dataset;
                  
        switch (action) {
          case 'select-thumb':
            this.querySelectorAll('[data-action="select-thumb"].selected')
              .forEach((el) => {
                el.classList.remove('selected');
                el.setAttribute('aria-current', 'false');
              });
            clickedElement.classList.add('selected');
            clickedElement.setAttribute('aria-current', 'true');
            
            this.querySelector('[data-product-images="main"]')
              ?.prepend(this.querySelector(`[data-product-images="main"] > [data-index="${index}"]`));
          break;
          case 'product-select':
            if (productId === this.selectedProduct?.id) return;
            
            this.selectedProduct = this.products.find(({ id }) => id === productId);
            history.replaceState(this.selectedProduct.title, '', this.selectedProduct.url);
            
            [...document.querySelectorAll('[data-show]')].forEach((el) => {
              if (Number(el.dataset.show) === Number(this.selectedProduct.id)) {
                el.style.display = null;
                if (el.querySelector('swiper-carousel')) {
                  setTimeout(() => {
                    el.querySelector('swiper-carousel').reinit();
                  }, 10);
                }
                return;
              }
              el.style.display = 'none';
            });
            
            const executeSteps = () => {
              document.querySelectorAll('script[src*="offers.pearcommerce.com/js/sdk.js"]').forEach(s => s.remove());
          
              const sectionWrapper = document.querySelector('[data-section="store-locator-widget"]');
              sectionWrapper.innerHTML = `<div id="${mapHandle ? `${mapHandle}-pear-map-target-${mapType}` : `pear-map-target-${mapType}`}"></div>`;
          
              const e = { vendorId: '2387972052853590', widget: 'product-locator' };
              const s = document.createElement("script");
              s.type = "text/javascript";
              s.src = "https://offers.pearcommerce.com/js/sdk.js?config=" + encodeURIComponent(JSON.stringify(e));
              s.onload = () => console.log("Script replaced and section wrapper updated.");
              document.head.appendChild(s);
            };
            
            executeSteps();
              
            this.detailsWrapper.innerHTML = document.querySelector(`[data-details-module="${this.selectedProduct.id}"]`).innerHTML;
            
            this.populateSelectedProductImages();

            const flavorDisplayEl = this.querySelector('[data-display="flavor"]');
            if (flavorDisplayEl) {
              flavorDisplayEl.innerHTML = this.selectedProduct.flavor;
            }          
                          
          default: break;
        }
      })
    }
    
    createCustomEvents() {
      this.productUpdatedEvent = new CustomEvent('coco-shuffle:product-updated', {});
    }
    
    populateSelectedProductImages() {
      this.imagesWrapper.forEach(wrapper => {
        // set this min height to prevent big reflow
        wrapper.style.minHeight = `${wrapper.offsetHeight}px`;

        wrapper.innerHTML = '';
        if (wrapper.dataset.productImages === "thumbnail") {
          this.selectedProduct.media.forEach((media, i) => {
            const { alt, poster, src } = media;
            
            wrapper.innerHTML += `
              <button 
                type="button"
                data-action="select-thumb"
                aria-label="Image ${i+1} of ${this.selectedProduct.media.length}"
                data-index="${i}"
                aria-current="${i === 0 ? 'true' : 'false'}"
                class="${i === 0 ? 'selected' : ''}"          
              >
                <img 
                  height="1200" 
                  width="1200" 
                  sizes="(min-width:768px) 600px, (min-width:1600px) 800px, (min-width:2000px) 1200px" 
                  alt="${alt ? alt : this.selectedProduct.title}" 
                  src="${poster ? poster : src}"
                >
              </button>
            `; 
          });
          return;
        }
        
        this.selectedProduct.media?.forEach((media, i) => {
          if (media.media_type === 'video') {
            const { alt, poster, sources } = media;
            const source = sources.find(x => x.format === 'mp4');
            if (!source) return;
            
            const template = this.querySelector('[data-template="product-video"]')?.innerHTML.toString();
            const templateString = template.replaceAll('{poster}', poster).replaceAll('{alt}', alt).replaceAll('{source}', source.url).replaceAll('{mime_type}', source.mime_type);
            const templateElement = document.createElement('div');
            templateElement.innerHTML = templateString;
            const templateNode = templateElement.firstElementChild;
            wrapper.appendChild(templateNode);

            return;
          }
          
          // is there a template defined?
          const template = this.querySelector('[data-template="product-image"]')?.innerHTML.toString();
          const { alt, src, variants } = media;
          
          if (!template) { 
            wrapper.innerHTML += `
              <img height="1200" width="1200" sizes="(min-width:768px) 600px, (min-width:1600px) 800px, (min-width:2000px) 1200px" alt="${alt ? alt : this.selectedProduct.title}" src="${src}">
            `; 
            return;
          }
          
          const loadedImage = new Image();
          loadedImage.src = src;
          
          const templateString = template.replaceAll('{src}', src).replaceAll('{alt}', alt).replaceAll('{variants}', variants).replaceAll('{classes}', '').replaceAll('{index}', i);
          const templateElement = document.createElement('div');
          templateElement.innerHTML = templateString;
          const templateNode = templateElement.firstElementChild;
          wrapper.appendChild(templateNode);
          
          setTimeout(() => {
            this.querySelector('swiper-carousel')?.reinit();
          }, 100);

        });       
      });
    }
  }
    
  customElements.define('coco-shuffle', CocoShuffle);
}